import { mockAPI } from './mockAPI';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://culturist-production.up.railway.app';

let USE_MOCK_API = false;

const checkBackendHealth = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/health`, {
      method: 'GET',
      timeout: 5000
    });
    return response.ok;
  } catch (error) {
    console.warn('Backend not available, using mock API:', error.message);
    return false;
  }
};

export const apiClient = {
  async init() {
    const isBackendHealthy = await checkBackendHealth();
    USE_MOCK_API = !isBackendHealthy;
    console.log(USE_MOCK_API ? 'Using mock API' : 'Using live backend');
  },

  async onboarding(data) {
    if (USE_MOCK_API) {
      return mockAPI.onboarding(data);
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/onboarding`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Onboarding API failed, using mock:', error);
      USE_MOCK_API = true;
      return mockAPI.onboarding(data);
    }
  },

  async venues(data) {
    if (USE_MOCK_API) {
      return mockAPI.venues(data);
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/venues`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Venues API failed, using mock:', error);
      USE_MOCK_API = true;
      return mockAPI.venues(data);
    }
  },

  async chat(data) {
    if (USE_MOCK_API) {
      return mockAPI.chat(data);
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/chat`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Chat API failed, using mock:', error);
      USE_MOCK_API = true;
      return mockAPI.chat(data);
    }
  },

  async health() {
    try {
      const response = await fetch(`${API_BASE_URL}/health`);
      return response.ok;
    } catch (error) {
      return false;
    }
  },

  async extractTastes(data) {
    if (USE_MOCK_API) {
      return mockAPI.extractTastes ? mockAPI.extractTastes(data) : { success: true, tastes: [] };
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/extract-tastes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Extract tastes API failed, using fallback:', error);
      return { success: true, tastes: [] };
    }
  },

  async refineRoute(data) {
    if (USE_MOCK_API) {
      return mockAPI.refineRoute ? mockAPI.refineRoute(data) : { success: true, route: [] };
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/refine-route`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Refine route API failed, using fallback:', error);
      return { success: true, route: [] };
    }
  },

  async qlooInsights(params) {
    if (USE_MOCK_API) {
      return mockAPI.qlooInsights ? mockAPI.qlooInsights(params) : { results: { clusters: [] } };
    }
    
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await fetch(`${API_BASE_URL}/api/qloo-insights?${queryString}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Qloo insights API failed, using fallback:', error);
      return { results: { clusters: [] } };
    }
  },

  async qlooSearch(query) {
    if (USE_MOCK_API) {
      return mockAPI.qlooSearch ? mockAPI.qlooSearch(query) : { results: [] };
    }
    
    try {
      const response = await fetch(`${API_BASE_URL}/api/qloo-search?q=${encodeURIComponent(query)}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.warn('Qloo search API failed, using fallback:', error);
      return { results: [] };
    }
  }
};
